import { isValid } from '@fnando/cpf';

export const isCPFValid = (value: string) => isValid(value, true);
